var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"inline-block"}},[_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:(_vm.label),expression:"label"}],staticClass:"custom-tooltip"},[_c('img',{attrs:{"src":require("@/assets/images/icons/info.svg")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }